import {Box, css, Stack, styled} from '@mui/material';
import {StyledProps} from './types';

export const NextAppointmentsContainer = styled(Stack)<StyledProps>`
	padding: 0;
	background-color: transparent;
	margin-inline: -4px;

	${({theme}) => theme.breakpoints.up('lg')} {
		margin-inline: -12px;
	}

	${({$noMargin}) =>
		$noMargin &&
		css`
			${({theme}) => theme.breakpoints.up('xs')} {
				margin-inline: 0;
			}
		`}
`;

export const EmptyStateDashedBox = styled(Box)`
	padding: 16px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-radius: 8px;
	background-color: ${({theme}) => theme.palette.primary.contrastText};
	border: 1px dashed rgba(0, 0, 0, 0.12);
	min-height: 60px;
`;

export const StyledBox = styled(Box)<StyledProps>`
	${({theme}) => theme.breakpoints.up('lg')} {
		padding: 4px;
	}

	${({theme}) => theme.breakpoints.down('sm')} {
		& .slide {
			flex-basis: 90%;
		}

		& .slide:first-of-type {
			flex-basis: 95%;
		}

		& .slide:last-of-type {
			flex-basis: 95%;
		}
	}

	${({$isSingleItem}) =>
		$isSingleItem &&
		css`
			${({theme}) => theme.breakpoints.down('sm')} {
				& .slide {
					flex-basis: 100%;
				}

				& .slide:first-of-type {
					flex-basis: 100%;
				}

				& .slide:last-of-type {
					flex-basis: 100%;
				}
			}
		`}
`;
